import PropTypes from "prop-types";
import { StyledLink } from "./AnchorLink.styles";

const AnchorLink = (props) => {
    return (
        <StyledLink
            {...props}
            href={props.href ? props.href : void 0}
            onClick={
                props.onClick && !props.disabled ? props.onClick : void 0
            }
        >
            {props.children}
        </StyledLink>
    );
};

AnchorLink.propTypes = {
    href: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    noUnderline: PropTypes.bool,
    noHover: PropTypes.bool,
    color: PropTypes.string,
    children: PropTypes.node,
};

export default AnchorLink;
